module.exports = __webpack_public_path__ + "img/德国站.ca7eadff.png";